import styled from 'styled-components';

const CardLogo = styled.img`
width: auto;
height: 230px;
border-radius : 0px 0px 0px 8px;
@media screen and (max-width:1000px){
    width: auto;
    height: 25vh;
  }
`;

export default CardLogo;
